import {AlertService} from '../../service/alert.service';
import {
    AbstractControl,
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup
} from '@angular/forms';
import {Router} from '@angular/router';
import {ASecureForm} from './ASecureForm';
import {AuthenticationService} from '../../service/authentication.service';
import {EnvironmentService} from '../../service/environment.service';

export abstract class SubmitForm extends ASecureForm
{
    submitted: boolean;
    loading = false;
    form: UntypedFormGroup;

    protected constructor(
        protected router: Router,
        protected formBuilder: UntypedFormBuilder,
        protected alertService: AlertService,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
    )
    {
        super(authenticationService, environmentService);
    }

    // convenience getter for easy access to form fields
    get f()
    {
        return this.form.controls;
    }

    displayError(control: AbstractControl)
    {
        if (control instanceof UntypedFormControl || control instanceof UntypedFormArray)
        {
            return ((control.touched || control.dirty) && control.errors) || (this.submitted && control.errors);
        }
    }

    displayArrayElementError(array: AbstractControl, index: number, elementForm: string)
    {
        const control = (<UntypedFormArray> array).controls[index].get(elementForm);

        if (control instanceof UntypedFormControl || control instanceof UntypedFormArray)
        {
            return ((control.touched || control.dirty) && control.errors) || (this.submitted && control.errors);
        }
    }

    validateAllFormFields(formGroup: UntypedFormGroup)
    {
        Object.keys(formGroup.controls).forEach(field =>
        {
            const control = formGroup.get(field);
            if (control instanceof UntypedFormControl)
            {
                control.markAsTouched({onlySelf: true});
            }
            else if (control instanceof UntypedFormGroup)
            {
                this.validateAllFormFields(control);
            }
        });
    }

    abstract submit(action): void;

    /**
     * Whether a guest admin may submit this form. Secure portal forms block guests; public pages
     * override this so a stale guest session in the tab does not lock them out.
     */
    protected allowsGuestUsers(): boolean
    {
        return false;
    }

    onSubmit(action = null): void
    {
        if (this.isGuestAdminUser() && !this.allowsGuestUsers())
        {
            this.alertService.error('Guest accounts cannot perform this action.', false);
            return;
        }

        this.submitted = true;

        if (this.form.status !== 'VALID')
        {
            this.debugOutput('form not valid: ' + this.form.errors + ' status: ' + this.form.status);
            this.alertService.error('Some form values are missing or invalid. Please ensure all required fields ' +
                'have been filled in with valid values.');
            return;
        }
        this.loading = true;
        this.submit(action);
    }
}